import React from 'react';
import {
  SentWithBonjoroBadgeTheme,
  SentWithBonjoroBadgeOpacity,
  SentWithBonjoroBadgeSize,
  SentWithBonjoroBadge,
  SentWithBonjoroBadgeProps,
} from '@vimily/bonjoro-ui-components-v2/SentWithBonjoroBadge';

export const BonjoroBadgeMobile = (props: SentWithBonjoroBadgeProps) => {
  return (
    <SentWithBonjoroBadge
      {...props}
      theme={SentWithBonjoroBadgeTheme.Black}
      size={SentWithBonjoroBadgeSize.Medium}
      opacity={SentWithBonjoroBadgeOpacity.Medium}
      target='_blank'
    />
  );
};
